import { styled } from '@spazious/dollhouse-theme';
import { getColor, PaletteColorsCustomizable, SizingNames } from '@spazious/dollhouse-theme';

import { BaseExtendProps, createBase } from '../Base/index.js';

export type TypographyElement = HTMLSpanElement;

export interface TypographyProps extends BaseExtendProps<React.HTMLAttributes<TypographyElement>> {
  color?: PaletteColorsCustomizable;
  // TODO use types from theme
  variant?: 'display' | 'headline' | 'body' | 'label' | 'title';
  size?: SizingNames;
  ellipsis?: boolean;
  noWrap?: boolean;
}

export const Typography = styled(createBase('span')).withConfig({
  shouldForwardProp: (prop) => !['variant', 'size', 'color', 'ellipsis', 'noWrap'].includes(prop),
  displayName: 'Typography',
})<TypographyProps>(
  ({ variant = 'body', size = 'medium', color = 'inherit', ellipsis, noWrap }) => `
    font-family: var(--spz-sys-typescale-${variant}-${size}-font-family-name);
    font-style: var(--spz-sys-typescale-${variant}-${size}-font-family-style);
    font-weight: var(--spz-sys-typescale-${variant}-${size}-font-weight);
    font-size: var(--spz-sys-typescale-${variant}-${size}-font-size);
    letter-spacing: var(--spz-sys-typescale-${variant}-${size}-letter-spacing);
    line-height: var(--spz-sys-typescale-${variant}-${size}-line-height);
    text-transform: var(--spz-sys-typescale-${variant}-${size}-text-transform);
    text-decoration: var(--spz-sys-typescale-${variant}-${size}-text-decoration);
    color: ${getColor(color)};
    ${ellipsis ? `text-overflow: ellipsis; overflow: hidden;` : ''}
    ${typeof noWrap === 'boolean' ? `white-space: ${noWrap ? 'nowrap' : 'normal'};` : ''}
`
);
